import { TemplateKey } from "PFApp/constants/templates";
import { Button, ButtonProps } from "PFComponents/button";
import { DropdownOption } from "PFComponents/dropdown/dropdown";
import { DropdownButton } from "PFComponents/dropdown_button";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useSubtemplates } from "PFCore/hooks/queries/subtemplates/use_subtemplates";
import { Subtemplate } from "PFTypes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type AddRoleButtonProps = {
  buttonKind?: ButtonProps["kind"];
  qaId?: string;
  optionQaIdPrefix?: string;
  onChange: (subtemplate?: Subtemplate) => void;
};

export const AddRoleWithSubtemplateButton = ({
  buttonKind = "secondary",
  qaId,
  optionQaIdPrefix,
  onChange
}: AddRoleButtonProps) => {
  const { data: subtemplates = [], isFetching } = useSubtemplates({ templateKey: TemplateKey.Role });
  const { t } = useTranslation("activities", { keyPrefix: "engagementBlueprint" });

  const options: DropdownOption[] = useMemo(
    () =>
      subtemplates.map((subtemplate) => ({
        id: subtemplate.subtemplate_key,
        displayElement: subtemplate.subtemplate_title,
        item: subtemplate,
        qaId: optionQaIdPrefix ? `${optionQaIdPrefix}.${subtemplate.subtemplate_key}` : undefined
      })),
    [subtemplates, optionQaIdPrefix]
  );

  if (subtemplates.length === 0) {
    return (
      <Button
        kind={buttonKind}
        text={t("addRole")}
        disabled={isFetching}
        onClick={() => onChange()}
        qaId={qaId}
      />
    );
  }

  return (
    <DropdownButton
      options={options}
      disabled={isFetching}
      handleChange={(subtemplate: Subtemplate) => {
        onChange(subtemplate);
      }}
      buttonKind={buttonKind}
      qaId={qaId}
    >
      <Typography variant="bodyButtons">{t("addRole")}</Typography>
      <Icon name="chevron-down" size="sm" />
    </DropdownButton>
  );
};
